import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import sx from './styles'

const EasyhowworksMobile = ({ items }) => {
  return (
    <Grid
      container
      p={2}
    >
      {items && items.map((item, index) => (
        <Grid
          key={`items-easy-${index}`}
          size={{
            xs: 6,
            sm: 4,
          }}
          sx={sx.listItem}
        >
          <Typography
            component="h4"
            sx={sx.listTextTitles}
            variant="h3"
          >
            <FormattedMessage id={item.title} />
          </Typography>

          <Typography variant="body1">
            <FormattedMessage id={item.description} />
          </Typography>
        </Grid>
      ))}

    </Grid>
  )
}

export default memo(EasyhowworksMobile)
